import React from 'react'

import anchorScroll from '../../../utils/anchorScroll'
import isLead from '../../../utils/isLead'

const Category = ({ category, location }) => {
  const onClick = () => {
    if(!isLead(location)) {
      anchorScroll('top', `/category/${category.alias}`) 
    }
  }


  const iconClass = function(iconName){
    if(iconName == 'Auto & Motorrad'){
      iconName = 'fa-truck-pickup';
    }
    if(iconName == 'Baby & Spielzeug'){
      iconName = 'fa-child';
    }
    if(iconName == 'Beauty & Gesundheit'){
      iconName = 'fa-heart';
    }
    if(iconName == 'Bürobedarf'){
      iconName = 'fa-marker';
    }
    if(iconName == 'Dienstleister'){
      iconName = 'fa-hands-helping';
    }
    if(iconName == 'Essen & Trinken'){
      iconName = 'fa-utensils';
    }
    if(iconName == 'Geschenke & Blumen & Lesen'){
      iconName = 'fa-gift';
    }
    if(iconName == 'Haus & Garten'){
      iconName = 'fa-home';
    }
    if(iconName == 'High-Tech'){
      iconName = 'fa-mobile-alt';
    }
    if(iconName == 'Mode'){
      iconName = 'fa-tshirt';
    }
    if(iconName == 'Online Kaufhäuser'){
      iconName = 'fa-cart-plus';
    }
    if(iconName == 'Reisen, Urlaub & Events '){
      iconName = 'fa-umbrella-beach';
    }
    if(iconName == 'Sport & Outdoor'){
      iconName = 'fa-futbol';
    }
    if(iconName == 'Lifestyle'){
      iconName = 'fa-smile';
    }
    return iconName
  }
  
  return(
    <li>
      <a className=''
          onClick={onClick}>
        <i className={`glyphicon ` + iconClass(category.title) + ` fas`} aria-hidden="true"></i>
        {category.title}
      </a>
    </li>
  )
}

export default Category



// WEBPACK FOOTER //
// ./src/components/Header/Explore/Category.js